export class Ssgdealer {

    id: number;
    vendorRegistrationId: string;
    applicationNumber: string;
    applicationDate: Date;
    dealsWith: string;
    description: string;
    prinicpal_Company_Name: string;
    address: string;
    telephone: string;
    nameofContactPerson: string;
    email: string;
    mobileNo: string;

    financialYear1: string;

    poNo1: string;
    poDate1: Date;
    poValue1: string;
    completionDate1: Date;
    client1: string;
    brief_Descriptionof_Work1: string;
    evaluatorsFigure1: string;
    comments1: string;

    poNo2: string;
    poDate2: Date;
    poValue2: string;
    completionDate2: Date;
    client2: string;
    brief_Descriptionof_Work2: string;
    evaluatorsFigure2: string;
    comments2: string;

    poNo3: string;
    poDate3: Date;
    poValue3: string;
    completionDate3: Date;
    client3: string;
    brief_Descriptionof_Work3: string;
    evaluatorsFigure3: string;
    comments3: string;


    total_Po_Value: string;
    comments_TotalValue: string;
    avg_Po_Value: string;
    ssgNo: string;
    ssgId :string;
    modified: Date;
    created: Date;
    createdBy: string;
    modifiedBy: string;

}
